<template>
  <div class="section-title">
    <h2 class="title font-semibold tracking-wide" :class="titleClasses">
      {{ title }}
    </h2>
    <p v-if="lead" class="subtitle 2xl:text-3xl text-xl sm:text-2xl">
      {{ lead }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    title: string
    lead?: string
    headingTag?: string
  }>(),
  {
    headingTag: 'h2',
    lead: '',
  },
)

const titleClasses = computed(() => {
  if (props.headingTag === 'h2') {
    return 'text-2xl sm:text-3xl lg:text-4xl'
  }
  return 'text-xl sm:text-2xl lg:text-3xl'
})
</script>

<style lang="postcss">
.section-title {
  margin-bottom: var(--section-gap-v);
  &.has-large-margin {
    margin-bottom: calc(var(--section-gap-v) * 0.5);
    @screen sm {
      margin-bottom: calc(var(--section-gap-v) * 0.5);
    }
  }
  .subtitle {
    margin-top: 0.5em;
  }
  @screen sm {
    margin-bottom: calc(var(--section-gap-v) * 0.25);
  }
}
</style>
